export default __webpack_public_path__ + "static/media/borda-esquerda-frente.bdc9b5a3.png";